import api from './api';

export interface TrendDataPoint {
  week: string;
  created: number;
  completed: number;
}

export interface AgeDistribution {
  range: string;
  count: number;
}

export interface HashtagStat {
  hashtag: string;
  open: number;
  completed: number;
  total: number;
}

export interface MeetingActionSummary {
  _id: string;
  title: string;
  date: string;
  openActions: number;
  oldestActionAge: number;
}

export interface WeeklyCount {
  week: string;
  count: number;
}

export interface DailyCount {
  date: string;
  count: number;
}

export interface EffectivenessBreakdown {
  noOpenActions: number;
  someOpenActions: number;
  onlyOpenActions: number;
}

export interface Insight {
  type: 'warning' | 'info' | 'success';
  message: string;
}

export interface ActionMetrics {
  totalActions: number;
  openActions: number;
  completedActions: number;
  completionRate: number;
  burnRate: number;
  oldestActionAge: number;
  trendData: TrendDataPoint[];
  ageDistribution: AgeDistribution[];
}

export interface MeetingMetrics {
  totalMeetings: number;
  meetingsThisMonth: number;
  meetingsLastMonth: number;
  avgActionsPerMeeting: number;
  incompleteAgendas: number;
  weeklyFrequency: WeeklyCount[];
  dailyFrequency: DailyCount[];
  effectiveness: EffectivenessBreakdown;
}

export interface DashboardMetrics {
  actionMetrics: ActionMetrics;
  meetingMetrics: MeetingMetrics;
  insights: Insight[];
}

export const getAnalyticsDashboard = async (
  period: '30d' | '90d' | 'all' = '90d',
  includeShared: boolean = true
): Promise<DashboardMetrics> => {
  const response = await api.get(`/analytics/dashboard?period=${period}&includeShared=${includeShared}`);
  return response.data;
};
